import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-faq-hero',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './faq-hero.component.html',
  styleUrls: ['./faq-hero.component.scss']
})
export class FaqHeroComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('faqHero', { static: false }) faqHero?: ElementRef;

  constructor(private analyticsService: AnalyticsService) {}

  ngOnInit() {
    // No necesita tracking de página aquí, se maneja en la página padre
  }

  ngAfterViewInit() {
    // Registrar la sección para tracking de analytics
    if (this.faqHero?.nativeElement) {
      this.analyticsService.registerSectionForTracking(
        this.faqHero.nativeElement,
        'FAQ Hero',
        'faq-hero-section'
      );
    }
  }

  ngOnDestroy() {
    // Cleanup si es necesario
  }
}
